import { MedicalTreatmentConsent, Patient } from '@dreryk/egabinet-patient-frontend-api';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';
import { MedicalTreatmentConsentPanel } from '../MedicalTreatmentConsentPanel';

import { MedicalTreatmentConsentWithdrawAction } from './MedicalTreatmentConsentWithdrawAction/MedicalTreatmentConsentWithdrawAction';

export type MedicalTreatmentConsentWithdrawPanelProps = {
   readonly patientId: Patient['id'];
   readonly enterDate: MedicalTreatmentConsent['enterDate'];
};

const MedicalTreatmentConsentWithdrawPanel = (props: MedicalTreatmentConsentWithdrawPanelProps): JSX.Element => {
   return (
      <MedicalTreatmentConsentPanel
         labelKey={patientConsentsAndAuthorizationsTranslationKeys.consent.granted}
         date={props.enterDate}
         testId={'medicalTreatmentConsentGrantedLabel'}
      >
         <MedicalTreatmentConsentWithdrawAction patientId={props.patientId} />
      </MedicalTreatmentConsentPanel>
   );
};

export { MedicalTreatmentConsentWithdrawPanel };
